// extracted by mini-css-extract-plugin
export default {"code":"code-MadXX","codeMain":"code-main-pZJTX","codeMainClose":"code-main-close-bTUr5","codeMainBtn":"code-main-btn-v8xnl"};